var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardhome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.5H14",
    stroke: "#4B525B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35139 13.7135C1.99837 11.4162 1.82186 10.2676 2.25617 9.24938C2.69047 8.23112 3.65403 7.53443 5.58114 6.14106L7.02099 5.1C9.41829 3.36667 10.6169 2.5 12 2.5C13.3831 2.5 14.5817 3.36667 16.979 5.1L18.4189 6.14106C20.346 7.53443 21.3095 8.23112 21.7438 9.24938C22.1781 10.2676 22.0016 11.4162 21.6486 13.7135L21.3476 15.6724C20.8471 18.9289 20.5969 20.5572 19.429 21.5286C18.2611 22.5 16.5537 22.5 13.1388 22.5H10.8612C7.44633 22.5 5.73891 22.5 4.571 21.5286C3.40309 20.5572 3.15287 18.9289 2.65243 15.6724L2.35139 13.7135Z",
    stroke: "#4B525B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardhome);
export default __webpack_public_path__ + "static/media/dashboardhome.093f1e9c1a397eb7990d9e9a630b70dc.svg";
export { ForwardRef as ReactComponent };